import { languageDataLocalizationMap } from '../../../Core/Localization/language-localization.model';
import { DropdownOptionModel } from '../models/dropdown-option.model';

export const translationLanguageOptions: DropdownOptionModel[] = [
    {
        value: 'Danish',
        label: languageDataLocalizationMap['en-US.da'],
        subLabel: 'da'
    },
    {
        value: 'Dutch',
        label: languageDataLocalizationMap['en-US.nl'],
        subLabel: 'nl'
    },
    {
        value: 'American English',
        label: languageDataLocalizationMap['en-US.en-US'],
        subLabel: 'en-US'
    },
    {
        value: 'British English',
        label: languageDataLocalizationMap['en-US.en-GB'],
        subLabel: 'en-GB'
    },
    {
        value: 'Finnish',
        label: languageDataLocalizationMap['en-US.fi'],
        subLabel: 'fi'
    },
    {
        value: 'Parisian French',
        label: languageDataLocalizationMap['en-US.fr-FR'],
        subLabel: 'fr-FR'
    },
    {
        value: 'Canadian French',
        label: languageDataLocalizationMap['en-US.fr-CA'],
        subLabel: 'fr-CA'
    },
    {
        value: 'German',
        label: languageDataLocalizationMap['en-US.de'],
        subLabel: 'de'
    },
    {
        value: 'Italian',
        label: languageDataLocalizationMap['en-US.it'],
        subLabel: 'it'
    },
    {
        value: 'Norwegian',
        label: languageDataLocalizationMap['en-US.no'],
        subLabel: 'no'
    },
    {
        value: 'Portuguese',
        label: languageDataLocalizationMap['en-US.pt'],
        subLabel: 'pt'
    },
    {
        value: 'Spanish',
        label: languageDataLocalizationMap['en-US.es'],
        subLabel: 'es'
    },
    {
        value: 'Swedish',
        label: languageDataLocalizationMap['en-US.sv'],
        subLabel: 'sv'
    }
];
